import AmendTransaction from './AmendTransactionContainer';

export default AmendTransaction;